var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMedium(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2108_28785)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8267 7.00012C13.8267 10.8661 10.9224 14 7.34007 14C3.75772 14 0.853271 10.8653 0.853271 7.00012C0.853271 3.13489 3.7575 0 7.34007 0C10.9226 0 13.8267 3.13418 13.8267 7.00012Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9426 7.00023C20.9426 10.6392 19.4905 13.5903 17.6992 13.5903C15.9079 13.5903 14.4558 10.6392 14.4558 7.00023C14.4558 3.36128 15.9077 0.410156 17.699 0.410156C19.4903 0.410156 20.9424 3.36033 20.9424 7.00023",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8532 7.0001C23.8532 10.2597 23.3426 12.9038 22.7125 12.9038C22.0824 12.9038 21.572 10.2604 21.572 7.0001C21.572 3.73979 22.0827 1.09644 22.7125 1.09644C23.3424 1.09644 23.8532 3.73955 23.8532 7.0001Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2108_28785"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 14,
    fill: "white",
    transform: "translate(0.853271)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.24577c6a.svg";
export { ForwardRef as ReactComponent };